import * as types from '../actions/menu-actions';

const initialState = {
	navActive: null,
	state: false,
};

const menuReducer = function (state = initialState, action) {
	switch (action.type) {
		case types.RESET_VALUES:
			return Object.assign({}, state, initialState);
			break;


		case types.NAVIGATION_CLICK:
			return Object.assign({}, state, {
				navActive: action.item
			});
			break;

		case types.TOGGLE_MENU:
			return Object.assign({}, state, {
				state: action.state
			});
			break;
	}

	return state;
};

export default menuReducer;



// WEBPACK FOOTER //
// ./src/reducers/menu-reducer.js